import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import fullLogo from "../assets/full_logo.png";
import {
  COMPANY_ADDRESS,
  COMPANY_EMAIL,
  COMPANY_PHONE,
  navItems,
  socialLinks,
} from "../siteData";

export default function Footer() {
  const appContext = useContext(AppContext);

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand-column">
            <img src={fullLogo} alt="MS Universal Distributors" className="footer-logo" />
            <p>
              MS Universal Distributors supplies quality goods and delivers
              professional cleaning services with consistency, elegance, and
              dependable customer support.
            </p>
            <div className="social-link-row">
              {socialLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    className="social-link-tile"
                    target="_blank"
                    rel="noreferrer"
                    aria-label={link.label}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h3>Navigation</h3>
            <div className="footer-links">
              {navItems.map((link) => (
                <button
                  key={link.item}
                  onClick={() => appContext.navTo({ item: link.item })}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3>Contact</h3>
            <div className="footer-links footer-text-links">
              <a href="tel:+255658902790">{COMPANY_PHONE}</a>
              <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>
              <p>{COMPANY_ADDRESS}</p>
            </div>
          </div>

          <div>
            <h3>Focus</h3>
            <div className="footer-links footer-text-links">
              <p>Importation and supplies</p>
              <p>Residential cleaning</p>
              <p>Deep cleaning services</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright MS Universal Distributors {getCurrentYear()}</p>
          <p>
            Website developed by{" "}
            <a className="werenium" href="https://werenium.com">
              Werenium Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
